import { ModelHelper } from '../classes/model-helper';

export class Service {
	uid: string;
	name: string;
	displayName: string;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns Service
	 */
	static map(data: any, item: Service = new Service()): Service {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return Service
	 */
	public map(data: any): Service {
		ModelHelper.map(data, this, 'uid');
		ModelHelper.map(data, this, 'name');
		ModelHelper.map(data, this, 'displayName');

		// When display name is missing
		if (data['name'] && !this.displayName) {
			ModelHelper.map(data, this, 'displayName', null, 'name');
		}

		return this;
	}
}
